import CouponeIcon from '@mui/icons-material/LocalOffer';

import CouponsList from './CouponsList';

export default {
      list: CouponsList,
      icon: CouponeIcon,
}